const serializeNodes = (editor, elements, errorMessage) => {
  try {
    const serialized = {
      formatVersion: editor.formatVersion,
      children: elements
    };
    return JSON.stringify(serialized);
  } catch (e) {
    throw new Error(errorMessage || `Editor: serialization error`);
  }
};
export {
  serializeNodes
};
//# sourceMappingURL=serializeNodes.js.map
